module.exports = __webpack_public_path__ + "img/multiplayer-game-Tashii-Designs.60f7ba89.png";